import { render } from "./CaptchaModal.vue?vue&type=template&id=4b557747&scoped=true"
import script from "./CaptchaModal.vue?vue&type=script&lang=js"
export * from "./CaptchaModal.vue?vue&type=script&lang=js"

import "./CaptchaModal.vue?vue&type=style&index=0&id=4b557747&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b557747"]])

export default __exports__